import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import aanuAvatar from '../OrgImages/Aanuavatar.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgBusinessModelShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'width');

  return (
    <section ref={sectionRef} className='relative h-full w-full overflow-hidden bg-brand-500'>
      <div className='flex h-full w-full justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle} className='flex flex-col px-12 pb-12 pt-24'>
            <h1 className='m-0 text-display-lg font-bold text-white tracking-[-0.96px]'>
              The Experteer filled a gap we would have struggled to solve on our own. They brought{' '}
              <span className='text-accent-500'>the missing piece.</span>
            </h1>
            <div className='mt-12 border-t border-white/30' />
            <div className='mt-8 flex items-center gap-3'>
              <img src={aanuAvatar} alt='' className='h-12 w-12' />
              <div className='flex flex-col'>
                <span className='text-base font-bold text-white'>Aanu Gopald</span>
                <span className='text-base font-normal text-white'>Founder of Africa Agility</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
